import React, { useState, useEffect, useContext } from "react";
import { useLocation } from 'react-router-dom';
//import NotFound from "./NotFoundPage";
import ReactGrid from "./React-Grid";
import ReactBootstrapModal from './UI/ReactBootstrapModal';
import Button from 'react-bootstrap/Button'; 
import MobileTableInfo from "./UI/MobileTableInfo";
import { createGridColumns, addToWatchList, removeFromList, checkIsPremium, maskingString, minPremiumAmount } from "../Utils/utils";
import * as httpService from '../services/HTTPService';
import WOW from 'wowjs';
import HeaderSocialLinks from "./HeaderSocialLinks";
import { Chart } from "react-google-charts";
import { AriaIntervalChart } from "./UI/ReactGoogleAriaChart";
import headerSocialLinksArray from "./HeaderSocialLinks";
import { isTelegramWebApp } from "../Utils/utils";
import { useNavigate } from "react-router-dom";
import PremiumPopop from "./UI/PremiumPopup";
import { WalletContext } from "../contexts/Wallet-context";
import Modal from 'react-bootstrap/Modal';
import CallersList from "./CallersListPage";
import { formatDateTimeStrNewLine } from "../Utils/gridColumns";

const TokenDetails = (props) => {
    const location = useLocation();
    const navigateRouter = useNavigate();
    const [rowData, setRowData]  = useState(location.state ? location.state.rowData : "");
    const [topRowData, setTopRowData]  = useState(location.state ? location.state.rowData : "");
    const [AVG_CallImmediateEffect, setAVG_CallImmediateEffect]  = useState(rowData !== "" ? rowData[0].AVG_CallImmediateEffect : "");
    const [AVG_FromCallToPeak, setAVG_FromCallToPeak] = useState(rowData !== "" ? rowData[0].AVG_FromCallToPeak : "");
    const [AVG_TracingImpact, setAVG_TracingImpact] = useState(rowData !== "" ? rowData[0].AVG_TracingImpact : "");
    const group = window.location.href.split('/').pop();
    const decodedUrlGroup = decodeURIComponent(group);
    let [watchListStorage, setWatchListStorage] = useState(null);
    let [isWatched, setIsWatched] = useState(false);
    let nameOfCallGroup  = location.state ? location.state.callGroup : decodedUrlGroup;
    const [isPremium, setIsPremium] = useState(checkIsPremium());
    const [isChecked, setIsChecked] = useState(false);
    const walletContext = useContext(WalletContext);
    const { wallet, setWallet } = walletContext;
    const [isOpenGrid, setIsOpenGrid] = useState(true);
    const [isOpenTopGrid, setIsOpenTopGrid] = useState(true);

    if(isTelegramWebApp) {
        // open this page into modal dialog, so get the name from props
        if(props.nameOfCallGroup) {
            nameOfCallGroup = props.nameOfCallGroup;
        } 
    }
    const [modalShow, setModalShow] = React.useState(false);
    let numberColumn = {valueGetter: "node.rowIndex + 1", headerName: "#", width: 60, sortable: false, suppressSorting: true};
    // , 'OrderNumber'
    // 'NameOfCallGroup',
    const gridCols = ['CallsFullTokenName', 'Timestamp', 'Chain', 'BuyLink', 'TokenHash', 'BuyLinkCalls', 'TotalMarketCapIN', 'TotalMarketCap', 'Liquidity', 'ImpactOfCall', 'SuccessRate', 'FromCalltoPeak', 'VolumeGenereted_h24'];
    let initialColumns = createGridColumns(gridCols, true);
    let [columnDefs, setColumnDefs] = useState(initialColumns);
    let extraColumns = createGridColumns(['PriceUSD', 'Holders', 'CryptoTokenCall', 'Source']);
    const [cryptoGroupImageUrl, setCryptoGroupImageUrl] = useState('');
    const [cryptoGroupInfo, setCryptoGroupInfo] = useState('');
    const [socialLinks, setSocialLinks] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [expanded, setExpanded] = useState(false);
    let [itemId, setItemId] = useState('');
    const getData = () => {
        httpService.getSingleItem(nameOfCallGroup).then((res) => {
            if(res && res.length > 0) {
                if(res[0].CryptoGroupImage && res[0].CryptoGroupImage !== '') {
                    setItemId(res[0].ID)
                    itemId = res[0].ID;
                    let imgSrc = res[0].CryptoGroupImage;
                    const folderName = '/callgrimages/';
                    
                    if(imgSrc === null || imgSrc.startsWith('https://shillguard-001')) {
                        // TOP 5 Callers
                        const imgName = imgSrc.split('/').pop();
                        const img = folderName + imgName;
                        imgSrc = img;
                    }

                    setCryptoGroupImageUrl(imgSrc);
                }
                if(res[0].CryptoGroupInfo) {
                    setCryptoGroupInfo(res[0].CryptoGroupInfo);
                }
                let mainData = [];
                let topData = [];
                for(var i = 0; i < res.length; i++) {
                    const cryptoGroup = res[i];
                    if(cryptoGroup.OrderNumber === 0) {
                        mainData.push(cryptoGroup);
                    }
                    else{
                        topData.push(cryptoGroup);
                    }
                }

                if(socialLinks.length === 0) {
                    const arr = [ 
                        {
                            link: res[0].TwitterLink,
                            icon:  isTelegramWebApp() ? '/img/social/header-social/X_20x20_white.svg' : '/img/social/header-social/X_20x20.svg',
                            whiteIcon: '/img/social/header-social/X_20x20_white.svg',
                            class: 'tw-link',
                            name: 'Twitter',
                            text: 'Follow us on Twitter to stay in the loop with real-time crypto trends, Shillguard news, and engaging discussions.',
                        },
                        {
                            link: res[0].TelegramLink,
                            icon: isTelegramWebApp() ? '/img/social/header-social/Telegram_20x20_white.svg' :  '/img/social/header-social/Telegram_20x20.svg',
                            whiteIcon: '/img/social/header-social/Telegram_20x20_white.svg',
                            class: 'tel-link',
                            name: 'Telegram',
                        }
                    ]
                    setSocialLinks(arr);
                }

                //const tData = res.filter(g => g.OrderNumber !== 0).sort((a, b) => a.OrderNumber - b.OrderNumber);
                //const uniqueData = [...new Map(tData.map(item => [item['OrderNumber'], item])).values()];
                  
                //setTopRowData(tData);
                //setRowData(res);
                const orderedTopData = topData.sort((a, b) => a.OrderNumber - b.OrderNumber);
                setTopRowData(orderedTopData);
                if(!isPremium) {
                   // console.log(orderedTopData)
                    //console.log(Object.keys(orderedTopData))
                    // for(var item of orderedTopData) {
                    //    console.log(Object.keys(item))
                    // }
                }
                setRowData(mainData);
                setAVG_CallImmediateEffect(res[0].AVG_CallImmediateEffect);
                setAVG_FromCallToPeak(res[0].AVG_FromCallToPeak);
                setAVG_TracingImpact(res[0].AVG_TracingImpact);
            }
        })
    }

    const modifyColumns = (data) => {
        const storageColumns = localStorage.getItem('tokenDetailsColumns');
        if(storageColumns) {
          if(data.length > 0) {
            setColumnDefs(data);
          }
        }
        else {
          setColumnDefs(initialColumns);
        }
        setModalShow(false);
      }
    //const groupSuccessColumns = createGridColumns(['number', 'ImpactOfCall', 'SuccessRate', 'FromCalltoPeak']);

    let [visible, setVisible] = useState('');

    const showGroupSuccessInfo = () => {
        if(visible === '') {
            setVisible('visible');
            visible = 'visible';
        }
        else{
            setVisible('');
            visible = '';
        }
    }

    const imgSrc = (base64Str) => {
        let src = "";
        if(rowData !== "") {
            let str = base64Str.replace(/(\r\n|\n|\r)/gm, "");
            if(!str.startsWith('data:image', 10)) {
                str = "data:image/png;base64, " + base64Str.replace(/(\r\n|\n|\r)/gm, "");
            }
            src = str;
        }
        if(base64Str.startsWith('http')) {
            return base64Str;
        }
        return src;
    }

    const hideInfo = (e) => {
        var popups = document.querySelectorAll('.info-popup');
        for(var i = 0; i < popups.length; i++) {
            if(popups[i].style.display === 'block') {
                popups[i].style.display = 'none';
            }
            if(popups[i].classList.contains('visible')) {
                popups[i].classList.remove('visible');
                setVisible('');
                visible = '';
            }
        }
    }

    const navigateToPage = (url) => {
        navigateRouter(url);
    }

    const TokenDPageComp = () => {

        const [show, setShow] = useState(false);
        const [currentPageComponent, setCurrentPageComponent] = useState("tokenDetails");
        const [modalParameterName, setModalParameterName] = useState('');
        const [modalTitle, setModalTitle] = useState('');

        const triggerModal = (trigger) => {
            if(trigger) {
                setShow(true);
            }
        }

        const getModalParameterName = (name) => {
            setModalParameterName(name);
        }

        const getModaTitle = (title) => {
            setModalTitle(title);
        }

        const getCurrentPageComponent = (comp) => {
            setCurrentPageComponent(comp);
        }

        const ModalDialog = (props) => {
            const handleClose = () => setShow(false);
            return (
                <Modal className='sgt-dialog title-line' show={show} setFullscreen={true} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{props.title || ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CallersList name={modalParameterName} />
                    </Modal.Body>
                </Modal>
            )
        }


        const addToWList = () => {
            let obj = {
                ID: itemId,
                NameOfCallGroup: decodeURI(nameOfCallGroup),
                CryptoGroupImage: cryptoGroupImageUrl
            }
            
            if(obj.ID && obj.ID !== "") {
                let isAdded = [];
                if(watchListStorage) {
                    isAdded = watchListStorage.filter((item) => {
                        return item.id === obj.ID;
                    })
                    if(isAdded && isAdded.length > 0) {
                        removeFromList(obj);
                        setIsWatched(false);
                    }
                }
                if(isAdded.length === 0) {
                    addToWatchList(obj);
                    setIsWatched(true);
                }

                let items = localStorage.getItem('watchlist');
                if(items) {
                    setWatchListStorage(JSON.parse(items));
                }
                else {
                    setWatchListStorage(null);
                }
            }
        }

        const toggleSection = (e) => {
            if(e && e.target) {
                setExpanded(!expanded);
            }
        }

        const addDefaultSrc = (e) =>{
            return e.target.src = '/img/no-image.png'
        }

        const openModal = (groupName) => {
            setShow(true);
            setModalParameterName(groupName);
        }

        const expandTopGrid = () => {
            setIsOpenTopGrid(!isOpenTopGrid);
        }

        const expandGrid = () => {
            setIsOpenGrid(!isOpenGrid);
        }

        const RedOrGreenColoring = (str, isPeak) => {
            let label = str;
            let txtColor = '';
            if(label) {
                txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label'
            }
            if(isPeak) {
                const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
                str = String(str).replace(emojiRegex, '');
            }
            return (
                <>
                    {str !== undefined ? (
                        <span className={txtColor}>{str}</span>
                    ) : null}
                </>
            )
        }

        

        return (
            <>
                <div className="flex-box token-d callers-top-info">
                    <div>
                        <div className="gray-bg gray-border" style={{'padding': '30px 20px', 'borderRadius': '15px'}}>
                            <div className="flex-box gap-20">
                                <div className="cryptoGroup-img" style={isTelegramWebApp() ? {'minWidth': '96px'} : null}>
                                    {cryptoGroupImageUrl !== '' ? (
                                        <img 
                                        style={{'width': '96px', 'margin': '0 0 20px 0', 'borderRadius': '70px'}} 
                                        src={cryptoGroupImageUrl} 
                                        alt ="cryptoGroupImage" 
                                    />
                                    ) : null}
                                </div>
                                <div style={{'flex': '1'}}>
                                    <div className="flex-box call-group-top-out" style={{'alignItems': 'baseline'}}>
                                        <div>
                                            <h1 className="inter-black-24" style={{'textAlign': 'left'}}>{decodeURIComponent(nameOfCallGroup)}</h1>
                                            {!isTelegramWebApp() ? (
                                                <p className="inter-medium-16 gray-txt" style={{"wordBreak": "break-word"}}>{cryptoGroupInfo}</p>
                                            ) : null}
                                        </div>
                                        {isTelegramWebApp() ? (
                                            <div className="flex-box" style={{"gap": "20px", 'marginLeft': 'auto'}}>
                                                <div className={isWatched ? "add-to-watch-list-btn watched" : "add-to-watch-list-btn"}  onClick={addToWList}>
                                                    <img src={isWatched ? "/img/star-24-blue.png" : "/img/sgt-tgr-favorites-icon.png"} alt="star" />
                                                </div>
                                                <div style={!isTelegramWebApp() ? {'marginLeft': 'auto'} : null}>
                                                    {socialLinks.length > 0 ? (
                                                        <HeaderSocialLinks links={socialLinks} />
                                                    ) : null}
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={!isTelegramWebApp() ? {'marginLeft': 'auto'} : null}>
                                                {socialLinks.length > 0 ? (
                                                    <HeaderSocialLinks links={socialLinks} />
                                                ) : null}
                                            </div>
                                        )}
                                        
                                    </div>
                                    {isTelegramWebApp() ? (
                                        <>
                                            <div className={`tgr-profile-txt ${expanded ? "sgt-expand" : "sgt-collapse"}`} >
                                                <div className="sgt-line"></div>
                                                <h4>Group text.</h4><span className="btn-toggle" onClick={(e) => toggleSection(e)}></span>
                                                <p className="inter-medium-16 gray-txt" style={{"wordBreak": "break-word", "margin": "10px 0"}}>{cryptoGroupInfo}</p>
                                                
                                            </div>
                                            <div className="sgt-line"></div>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                            <div>
                                <ul className='result-list'>
                                    <li>
                                        <div className="gradient-b">
                                            <div>
                                                <span className="inter-medium-16 gray-txt">Call Efc</span>
                                                <p>{parseFloat(AVG_CallImmediateEffect) < 0 ? (
                                                        <span className="red-value-label">{AVG_CallImmediateEffect}%</span>
                                                    ) : (
                                                        <span className="green-value-label">{AVG_CallImmediateEffect}%</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="gradient-b">
                                            <div>
                                                <span className="inter-medium-16 gray-txt">Trace</span>
                                                <p>{parseFloat(AVG_TracingImpact) < 0  ? (
                                                        <span className="red-value-label">{AVG_TracingImpact}%</span>
                                                    ) : (
                                                        <span className="green-value-label">{AVG_TracingImpact}%</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="gradient-b last">
                                            <div>
                                                <span className="inter-medium-16 gray-txt">Peak</span>
                                                <p>{parseFloat(AVG_FromCallToPeak) < 0 ? (
                                                        <span className="red-value-label">{AVG_FromCallToPeak}%</span>
                                                    ) : (
                                                        <span className="green-value-label">{AVG_FromCallToPeak}%</span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {!isTelegramWebApp() ? (
                            <div className="gray-border gray-bg" style={{'padding': '30px 20px', 'borderRadius': '15px', 'marginTop': '20px'}}>
                                {cryptoGroupInfo && cryptoGroupInfo !== '' ? (
                                    <div>
                                        <h3 className="avg-group-perf inter-bold-16">
                                            <img src="/img/sgt-group-perf.png" alt="group performance" style={{'marginRight': '10px'}} />
                                            This is the group’s average performance.
                                        </h3>
                                        <p className="inter-medium-16 gray-txt" style={{"marginBottom": "0"}}>
                                            To truly understand how and why they perform — including top calls, live signal 
                                            breakdowns, and consistency over time — unlock full analytics with our Premium Plan. 
                                            See if it’s just one lucky mooner… or a proven signal master.
                                        </p>
                                        {/* <p className="inter-medium-16 gray-txt">{cryptoGroupInfo}</p> */}
                                    </div>
                                ) : null} 
                            </div>
                        ) : null}
                        
                    </div>
                    {/* <div className="flex-box chart-el">
                        {chartData && chartData.length > 0 ? (
                            <div className="td-chart">
                                <AriaIntervalChart chartData={chartData} />         
                            </div>
                        ) : null}
                        
                    </div> */}
                </div>
                
                
                {/* <div style={{'marginTop': '48px'}} className={!isPremium ? "hidden-data" : ""}></div> */}
                <div style={{'marginTop': '48px'}} className={!isPremium ? "hidden-data" : ""}>
                    {!isPremium && isChecked ? (
                        <PremiumPopop />
                    ) : null}
                    <div className="wow fadeIn" data-wow-duration="0.7s" style={{"textAlign": "right"}}>
                        <MobileTableInfo />
                        <div className='desktop'>
                            <div className="descktop" style={{marginTop: "30px"}}></div>
                            {/* <Button variant="primary" onClick={() => setModalShow(true)} style={{'marginBottom': '15px', 'verticalAlign': 'top'}}>
                                <svg style={{"marginRight": "10px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" color="var(--c-color-gray-500)"><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13 5V19H9V5H13ZM5 5H7V19H5V5ZM15 19V5H19V19H15Z" fill="currentColor"></path></svg>
                                Customize
                            </Button> */}
                        </div>
                    </div>
                    <ReactBootstrapModal 
                        show={modalShow} 
                        onHide={() => setModalShow(false)} 
                        columns={columnDefs} 
                        initialColumns={initialColumns}
                        modifycolumns={modifyColumns}
                        extraColumns={extraColumns}
                        isHomePage={false}
                    />
                    <div className="token-grids wow fadeIn" data-wow-duration="1.5s">
                        <div className="topCallsGrid" >
                            {!isTelegramWebApp() ? (
                                <h3 className="inter-bold-16" style={{'margin' : '0', 'padding': '26px 0'}}>
                                    <img src="/img/sgt-grid-heading.png" alt="grid heading" style={{'margin' : '0 10px 0 20px'}} />
                                    All time top performers tokens
                                </h3>
                            ) : null}
                            
                            {isTelegramWebApp() ? (
                                // <div className='call-gr double-row-grid'>
                                <div>
                                    {/* <ReactGrid 
                                        tooltipInteraction={true} 
                                        columns={columnDefs} 
                                        sortable={false} 
                                        rowData={doubleRowData} 
                                        errorMessage={''} 
                                        triggerModal={triggerModal} 
                                        modalParameterName={getModalParameterName} 
                                        modalTitle={getModaTitle} 
                                        currentPageComponent={getCurrentPageComponent}
                                    /> */}
                                    {topRowData ? (
                                        <div className="toggle-li">
                                            <span>All-Time Top Performers</span>
                                            <span className={isOpenTopGrid ? "toggle-up" : "toggle-up toggle-down"} onClick={() => expandTopGrid()}>{">"}</span>
                                        </div>
                                    ) : null}
                                    {topRowData.length > 0 ? (
                                        <ul className={isOpenTopGrid ? "doble-list" : "doble-list hidden-double-list"}>
                                            {topRowData.map((r, index) => {
                                                return(
                                                    <li key={index} onClick={() => openModal(r.TokenHash)}>
                                                        <span>
                                                            <img onError={addDefaultSrc} src={r.TokenImage || '/img/no-image.png'} alt="icon" />
                                                        </span>
                                                        <span>
                                                            {/* <span>{r.TokenName}</span><br /> */}
                                                            <span>{r.TokenSymbol}</span><br />
                                                            {/* <span className="gray-txt">{r.TokenSymbol}</span><br /> */}
                                                            <span className="gray-txt">{r.Chain}</span>
                                                        </span>
                                                        <span>{r.TotalMarketCap}<br/><i>M.Cap</i></span>
                                                        <span>{r.Liquidity}<br/><i>LIQUIDITY</i></span>
                                                        <span>{r.PriceUSD}<br/><i>PRICE</i></span>
                                                        <span>{r.VolumeGenereted_h24}<br/><i>VOL(24h)</i></span>
                                                        <span></span>
                                                        <span><span className="gray-txt" style={{"fontSize": "13px"}} dangerouslySetInnerHTML={{__html: formatDateTimeStrNewLine(r.Timestamp)}}></span></span>
                                                        <span>{r.TotalMarketCapIN}<br/><i>CALL M.CAP</i></span>
                                                        <span>{RedOrGreenColoring(r.ImpactOfCall, false)}<br/><i>CALL EFC</i></span>
                                                        <span>{RedOrGreenColoring(r.SuccessRate, false)}<br/><i>TRACE</i></span>
                                                        <span>{RedOrGreenColoring(r.FromCalltoPeak, true)}<br/><i>PEAK</i></span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    ) : null}
                                </div>
                            ) : (
                                <ReactGrid 
                                    rowHeight={72} 
                                    mobileRowHeight={92} 
                                    tooltipInteraction={true} 
                                    columns={columnDefs} 
                                    sortable={false} 
                                    rowData={topRowData} 
                                    errorMessage={''} 
                                    triggerModal={triggerModal} 
                                    modalParameterName={getModalParameterName} 
                                    modalTitle={getModaTitle} 
                                    currentPageComponent={getCurrentPageComponent}
                                />
                            )}
                            
                        </div>
                        <div>
                            
                            {!isTelegramWebApp() ? (
                                <h3 className="inter-bold-16">
                                <img src="/img/sgt-grid-heading.png" alt="grid heading" style={{'margin' : '0 10px 0 20px'}} />
                                    Live token call feed
                                </h3>
                            ) : null}
                            {isTelegramWebApp() ? (
                                <div>
                                    {topRowData ? (
                                        <div className="toggle-li">
                                            <span>Live Token Call Feed</span>
                                            <span className={isOpenGrid ? "toggle-up" : "toggle-up toggle-down"} onClick={() => expandGrid()}>{">"}</span>
                                        </div>
                                    ) : null}
                                    {rowData.length > 0 ? (
                                        <ul className={isOpenGrid ? "doble-list" : "doble-list hidden-double-list"}>
                                            {rowData.map((r, index) => {
                                                return(
                                                    <li key={index} onClick={() => openModal(r.TokenHash)}>
                                                        <span>
                                                            <img onError={addDefaultSrc} src={r.TokenImage || '/img/no-image.png'} alt="icon" />
                                                        </span>
                                                        <span>
                                                            {/* <span>{r.TokenName}</span><br /> */}
                                                            <span>{r.TokenSymbol}</span><br />
                                                            {/* <span className="gray-txt">{r.TokenSymbol}</span><br /> */}
                                                            <span className="gray-txt">{r.Chain}</span>
                                                        </span>
                                                        <span>{r.TotalMarketCap}<br/><i>M.Cap</i></span>
                                                        <span>{r.Liquidity}<br/><i>LIQUIDITY</i></span>
                                                        <span>{r.PriceUSD}<br/><i>PRICE</i></span>
                                                        <span>{r.VolumeGenereted_h24}<br/><i>VOL(24h)</i></span>
                                                        <span></span>
                                                        <span><span className="gray-txt" style={{"fontSize": "13px"}} dangerouslySetInnerHTML={{__html: formatDateTimeStrNewLine(r.Timestamp)}}></span></span>
                                                        <span>{r.TotalMarketCapIN}<br/><i>CALL M.CAP</i></span>
                                                        <span>{RedOrGreenColoring(r.ImpactOfCall, false)}<br/><i>CALL EFC</i></span>
                                                        <span>{RedOrGreenColoring(r.SuccessRate, false)}<br/><i>TRACE</i></span>
                                                        <span>{RedOrGreenColoring(r.FromCalltoPeak, true)}<br/><i>PEAK</i></span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    ) : null}
                                    {/* <ReactGrid
                                        tooltipInteraction={true}
                                        columns={columnDefs} 
                                        sortable={true} 
                                        rowData={rowData} 
                                        errorMessage={''} 
                                        triggerModal={triggerModal} 
                                        modalParameterName={getModalParameterName} 
                                        modalTitle={getModaTitle} 
                                        currentPageComponent={getCurrentPageComponent}
                                    /> */}
                                </div>
                            ) : (
                                <ReactGrid 
                                    rowHeight={72} 
                                    mobileRowHeight={92} 
                                    tooltipInteraction={true}
                                    columns={columnDefs} 
                                    sortable={true} 
                                    rowData={rowData} 
                                    errorMessage={''} 
                                    triggerModal={triggerModal} 
                                    modalParameterName={getModalParameterName} 
                                    modalTitle={getModaTitle} 
                                    currentPageComponent={getCurrentPageComponent}
                                />
                            )}
                            
                        </div>
                        <div className='mob-900 cutomize-mob' style={{marginTop: "30px"}}>
                            {/* <Button variant="primary" onClick={() => setModalShow(true)} style={{'marginBottom': '15px', 'verticalAlign': 'top'}}>
                                <svg style={{"marginRight": "10px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" color="var(--c-color-gray-500)"><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13 5V19H9V5H13ZM5 5H7V19H5V5ZM15 19V5H19V19H15Z" fill="currentColor"></path></svg>
                                Customize
                            </Button> */}
                        </div>
                    </div>
                    <ModalDialog title={modalTitle} />
                </div>
            </>
        )
    }

    useEffect(() => {
        const lstrgWatch = localStorage.getItem('watchlist');
        if(lstrgWatch && lstrgWatch !== "[{}]") {
            setWatchListStorage(JSON.parse(lstrgWatch));
            watchListStorage = JSON.parse(lstrgWatch);
        }

        getData();

        new WOW.WOW({
            live: false
        }).init();

        document.addEventListener('click', (e) => {
            // if(e.target.classList.contains('info-icon')) {
            //     showInfo(e);
            // }
            if(e.target.classList.contains('close-btn')) {
                hideInfo(e);
            }
            if(!e.target.classList.contains('info-popup') && !e.target.classList.contains('info-icon')) {
                hideInfo(e);
            }
        })

        const storageColumns = localStorage.getItem('tokenDetailsColumns');
        if(storageColumns && storageColumns !== "null") {
            let additionalColumns = JSON.parse(storageColumns);
            //let columns = [...additionalColumns];
            const storageData = createGridColumns(additionalColumns)
            setColumnDefs(storageData);
        }
        else {
            // if(!columnDefs[0].valueGetter) {
            //     columnDefs[0] = numberColumn;
            // }
            setColumnDefs(columnDefs);
        }

        httpService.getChartData(nameOfCallGroup).then((res) => {
            if(res.status !== 400 && res.data.length > 0) {
                setChartData(res.data);
            }
        })

    }, [])


    useEffect(() => {
        if(watchListStorage && watchListStorage.length > 0) {
            if(itemId) {
                let isWatchedItem = watchListStorage.filter((item) => {
                    return item.id === itemId;
                }) 
                if(isWatchedItem.length > 0) {
                    setIsWatched(true);
                    isWatched = true;
                }
            }
        }
    }, [itemId, watchListStorage])

    useEffect(() => {
        const interval = setInterval(() => {
            getData();
          }, 30000);
          return () => clearInterval(interval);
    }, [])

    useEffect(() => {
        if(wallet) {
            const walletData = typeof wallet === "string" ? JSON.parse(wallet) : wallet;
            if(parseInt(walletData.amount) > parseInt(minPremiumAmount())) {
                //const amount = JSON.parse(wallet).amount ? JSON.parse(wallet).amount : null;
                const w = typeof wallet === "string" ? JSON.parse(wallet) : wallet;
                setIsPremium(checkIsPremium(w))
            }
            else {
                setIsChecked(true);
            }
            
        }
        else {
            setIsPremium(false);
            setIsChecked(true);
        }
        
    }, [wallet, walletContext])

    return (
        <div className="token-details">
            {isTelegramWebApp() ? (
                <div className="telegram-profile-page">
                    {/* <span className="btn-navigate" onClick={() => navigateToPage('/')}>X</span> */}
                    <TokenDPageComp />
                </div>
            ) : (
            <>
                <TokenDPageComp />
            </>
            )}
            
        </div>
    )
}

export default TokenDetails;